/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type Rubric from '@linc-technologies/linced-common/models/reports/rubric';
import type RubricElement from '@linc-technologies/linced-common/models/reports/rubric-element';

// Proto: reports.RubricCriteria.
export default class RubricCriteria extends Model {
  declare [Type]: 'reports/rubric-criteria';

  @belongsTo('reports/rubric', { async: true, inverse: null })
  declare rubricId: AsyncBelongsTo<Rubric>;

  @alias('rubricId')
  declare rubric: AsyncBelongsTo<Rubric>;

  @belongsTo('reports/rubric-element', { async: true, inverse: null })
  declare elementId: AsyncBelongsTo<RubricElement>;

  @alias('elementId')
  declare element: AsyncBelongsTo<RubricElement>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare progressColumn: number;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare text: string;

  @attr('string', { defaultValue: '' })
  declare achievedNarrative: string;

  @attr('string', { defaultValue: '' })
  declare helpAtHome: string;

  @attr('string', { defaultValue: '' })
  declare nextStep: string;

  @attr('string', { defaultValue: '' })
  declare stretchNextStep: string;

  @array('string')
  declare tags: StatefulArray<string>;
}
